<template>
  <div class="">
    <div
      class="flex-column align-items-end height32"
      :class="{'show-select-only': showTabs}"
    >
      <yxt-select
        v-if="showTabs"
        v-model="selectedCatalogId"
        size="small"
        :placeholder="$t('pc_gwnl_global_pleaseSelect')"
        @change="selectedCatalogHandler"
      >
        <yxt-option
          v-for="catalogs in catalogList"
          :key="catalogs.id"
          :disabled="catalogs.disabled"
          :label="catalogs.name"
          :value="catalogs.id"
        />
      </yxt-select>
    </div>
    <yxtf-scrollbar v-if="!noRight">
      <div
        class="gwnl-web-position-skills-right-content mt32 pt24"
      >
        <right-item
          v-if="disadvList && disadvList.length > 0"
          :detail="disadvList"
          :tag-style="!skillWithLevel"
          :type="2"
          :legends="legends"
        />
        <right-item
          v-if="advList && advList.length>0"
          :detail="advList"
          :tag-style="!skillWithLevel"
          :type="1"
          :legends="legends"
        />
        <yxtf-empty
          v-if="disadvList && disadvList.length === 0 && advList && advList.length === 0"
          class="mb47"
        />
      </div>
    </yxtf-scrollbar>
  </div>
</template>

<script>
import rightItem from './detailSkillsRightItem';

export default {
  components: {
    rightItem
  },
  props: {
    evaluationList: {
      type: Array,
      default: () => []
    },
    noRight: Boolean,
    fields: {
      type: Array,
      default: () => []
    },
    scene: {
      type: Number,
      default: 1 // 1 岗位地图 2 测训一体
    },
    detail: {
      type: Object,
      default: () => {}
    },
    skillWithLevel: Boolean
  },
  data() {
    return {
      selectedCatalogId: '',
      catalogList: [],
      propMap: ['before', 'after', 'after2', 'after3']
    };
  },
  computed: {
    disadvList() {
      if (this.scene === 1) {
        return this.detail.improve;
      } else {
        const catalog = this.catalogList.find(item => item.id === this.selectedCatalogId) || {};
        const props = catalog.props && catalog.props.disadvantaged || '';
        return this.detail[props] || [];
      }
    },
    advList() {
      if (this.scene === 1) {
        return this.detail.advantage;
      } else {
        const catalog = this.catalogList.find(item => item.id === this.selectedCatalogId) || {};
        const props = catalog.props && catalog.props.advantaged;
        return this.detail[props];
      }
    },
    showTabs() {
      if (this.scene === 2) {
        return !this.noRight && this.catalogList.length > 1;
      }
      return this.catalogList.length > 1;
    },
    legends() {
      return [
        {
          label: this.$t('pc_gwnl_web_standardValue'),
          propName: 'combStandardLevel',
          propLevelName: 'standardLevelName',
          propRange: this.scene === 2 ? 'standardLevel' : 'standardScore'
        },
        {
          label: this.$t('pc_gwnl_web_evalValue'),
          propName: this.scene === 2 ? this.propMap[+this.selectedCatalogId] + 'CompScore' : 'level',
          propLevelName: this.scene === 2 ? this.propMap[+this.selectedCatalogId] + 'CompLevelName' : 'compLevelName',
          propRange: this.scene === 2 ? '' : 'compScore'
        }
      ];
    }
  },
  watch: {
    fields: {
      deep: true,
      immediate: true,
      handler: function(v) {
        if (this.scene !== 2) {
          return;
        }
        this.catalogList = v.filter(field => (field.id !== '99' && field.id !== '98')).map(field => {
          return {
            ...field,
            id: field.id && field.id.slice(0, 1)
          };
        }).filter((value, index, self) => { // remove repeat item
          return self.findIndex(item => item.id === value.id) === index;
        }).map((item) => {
          return {
            name: (item.id === '0' ? this.$t('pc_gwnl_training_catalog_before') : (item.id === '1' ? this.$t('pc_gwnl_training_catalog_after') : this.$t('pc_gwnl_training_catalog_after') + this.$t('pc_gwnl_training_the_n_times', { n: item.id }))) + this.$t('pc_gwnl_web_evaluation'),
            id: item.id,
            disabled: item.disabled,
            props: {
              disadvantaged: this.propMap[+item.id] + 'JqSkillDisadvList',
              advantaged: this.propMap[+item.id] + 'JqSkillAdvList'
            }
          };
        }) || [];
        const catalogs = this.catalogList && this.catalogList.filter(item => !item.disabled) || [];
        this.selectedCatalogId = catalogs.length && catalogs[0].id || '';
      }
    },
    evaluationList: {
      deep: true,
      immediate: true,
      handler(v) {
        if (this.scene !== 2) {
          // 层级地图、岗位地图
          this.catalogList = v.length && v.map(el => {
            el.name = el.evalName;
            el.id = el.evalId;
            return el;
          });
          this.selectedCatalogId = v.length && v[v.length - 1].evalId;
        }
      }
    }
  },
  methods: {
    selectedCatalogHandler(v) {
      this.selectedCatalogId = v;
      this.$emit('getRadarDetail', v);
    },
    reset() {
      this.selectedCatalogId = this.evaluationList.length && this.evaluationList[this.evaluationList.length - 1].evalId;
    }
  }
};
</script>
<style lang="scss" scoped>
.height32 {
  height: 32px;
}

.flex-column {
  display: flex;
  flex-direction: column;
}

.align-items-end {
  align-items: flex-end;
}

.show-select-only {
  position: absolute;
  right: 0;
  //z-index: 999;
}
</style>
